<template>
  <div :class="computedWrapperClasses">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  centeredContent: {
    type: Boolean,
    default: false,
  },
  largePadding: {
    type: Boolean,
    default: false,
  },
  isTitle: {
    type: Boolean,
    default: false,
  },
});

const computedWrapperClasses = computed(() => [
  'content-wrapper',
  props.centeredContent && 'content-wrapper--center',
  props.largePadding && 'content-wrapper--large-padding',
  props.isTitle && 'content-wrapper--title',
]);
</script>

<style scoped lang="scss">
.content-wrapper {
  box-sizing: border-box;
  padding: var(--fh-size-2xl);

  @media only screen and (min-width: 680px) {
    border-radius: 16px;
  }
}

.content-wrapper--center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.content-wrapper--large-padding {
  /*
    We have set up a custom sized padding for the content panel.
    This panel displays status information of waivers, such as signed successfully or not available
  */
  padding: 152px var(--fh-size-2xl);

  @media only screen and (min-width: 680px) {
    padding: var(--fh-space-4xl);
  }
}

.content-wrapper--title {
  align-items: unset;

  @media only screen and (min-width: 680px) {
    align-items: center;
  }
}
</style>
